const formatDimensions = ({ width, height, length }) => (
  [length, width, height]
    .filter(x => x)
    .join(" × ")
);

export default formatDimensions;
